import 'dayjs/locale/es';
import { datadogLogs } from '@datadog/browser-logs';
import { useEffect } from 'react';
import AppRouter from './Router/Router';
import dayjs from 'dayjs';
import ReactGA from 'react-ga';

ReactGA.initialize(import.meta.env.VITE_GA || '');

if (import.meta.env.VITE_DATADOG_CLIENT_TOKEN) {
  datadogLogs.init({
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site: import.meta.env.VITE_DATADOG_API_HOST,
    forwardErrorsToLogs: true,
    sampleRate: 100,
    env: import.meta.env.VITE_ENV,
    service: 'account-vivus-es',
    version: import.meta.env.VITE_RELEASE_VERSION ?? undefined,
  });
}

function App() {
  useEffect(() => {
    dayjs.locale('es');
  }, []);

  return <AppRouter />;
}

export default App;
